<div class="pharma-financial-filter">
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton
      [customSkeletonConfig]="customSkeletonConfig"
    >
    </va-custom-skeleton>
  </div>
  <ng-container *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel) && data" >
    <div class="selected-items" *ngIf="filter && filter.financials && filter.financials.length">
      <ng-container *ngFor="let item of getFinancials(); index as idx">
        <div *ngIf="id !== item.id"
          class="data-section"
        >
          <div class="index">{{idx + 1}}</div>
          <div class="selected-data">
            <div>
              <span class="label">Line Item</span>
              <span class="value">{{getLILabel(item.selected_line_item)}}</span>
            </div>
            <div>
              <span class="label">Year</span>
              <span class="value">{{getYearLabel(item.selected_year)}}</span>
            </div>
            <div>
              <span class="label">{{data.meta.label}}</span>
              <span class="value">
                <ng-container
                  [ngTemplateOutlet]="amountFormatter"
                  [ngTemplateOutletContext]="{
                    amount: item.selected_min,
                    magnitude: data.meta.magnitude,
                    currency: data.meta.currency
                  }"
                >
                </ng-container> - 
                <ng-container
                  [ngTemplateOutlet]="amountFormatter"
                  [ngTemplateOutletContext]="{
                    amount: item.selected_max,
                    magnitude: data.meta.magnitude,
                    currency: data.meta.currency
                  }"
                >
                </ng-container>
                <!-- {{data.meta.currency}}{{item.selected_min}}{{data.meta.magnitude}} - {{data.meta.currency}}{{item.selected_max}}{{data.meta.magnitude}} -->
              </span>
            </div>
          </div>
          <div class="action">
            <span class="delete-icon">
              <va-icon
                size="small"
                name="trash"
                (click)="onDelete(idx)"
              ></va-icon>
            </span>
            <span class="edit-icon">
              <va-icon
                size="small"
                name="edit"
                (click)="onEdit(idx)"
              ></va-icon>
            </span>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="edit-section">
      <div  class="line-item-section">
        <div class="dd-container">
          <span class="label-and-select">
            <span class="label">Line Item</span>
            <nz-select
              [(ngModel)]="selected_line_item"
              (ngModelChange)="changeMinMax()"
              class="line-item">
              <nz-option
                *ngFor="let lineItem of data.meta.lineItemList"
                [nzValue]="lineItem.key"
                [nzLabel]="lineItem.label"
              ></nz-option>
            </nz-select>
          </span>
          <span class="label-and-select">
            <span class="label">Revenue Year</span>
            <nz-select
              [(ngModel)]="selected_year"
              (ngModelChange)="changeMinMax()"
              class="line-item">
              <nz-option
                *ngFor="let year of data.meta.yearList"
                [nzValue]="year.key"
                [nzLabel]="year.label"
              ></nz-option>
            </nz-select>
          </span>
        </div>
        <div class="slider-section">
          <app-pharma-slider-filter
            [label]="data.meta.label"
            [showLabel]="true"
            [min]="minValue"
            [max]="maxValue"
            [selectedMin]="selected_min"
            [selectedMax]="selected_max"
            [magnitude]="data.meta.magnitude"
            [currency]="data.meta.currency"
            [valueFormatter]="amountFormatter"
            (onSelectionChange)="onRangeChange($event)"
          ></app-pharma-slider-filter>
        </div>
      </div>
      <va-button
        *ngIf="!id"
        btnType="solid"
        size="medium"
        (click)="addFinancial()"
      >
        <va-icon
          size="small"
          name="plus"
          class="btn-icon"
        ></va-icon>
        <span class="btn-text">Add</span>
      </va-button>
      <va-button
        *ngIf="id"
        btnType="solid"
        size="medium"
        (click)="addFinancial()"
      >
        <span class="btn-text">Save</span>
      </va-button>
    </div>
  </ng-container>
  
</div>